import { z } from 'zod';

/**
 * The five Areté values a Spot nomination names. On its own so Home's contract (APP-232) can read
 * it without importing `spot.ts`, which reaches `home.ts` again through `operations.ts`.
 */
export const SpotValue = z.enum([
  'Creativity',
  'Integrity',
  'Passion',
  'Responsiveness',
  'Collaboration',
]);
